<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des rôles"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/role/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/role"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du rôle')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce rôle?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../components/DynamicCardList'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'RoleList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
            this.init()
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: window.Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Nom'),
                        key: 'name',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'name'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'number',
                            label: window.Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'name',
                            type: 'text',
                            label: window.Core.Definition.getDefinition('Nom'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            init() {
            },
            clickEdit(value, cell, row) {
                this.$router.push('/systeme/roles/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
